import { z } from "zod";

export const magazineTemplateSchema = () => {
  return z.object({
    file: z.any().optional().nullable(),
    cover: z.any().optional().nullable(),
    reference_month: z.number().refine((val) => val >= 0, {
      message: "reference_month must be zero or greater",
    }),
    reference_year: z.number().refine((val) => val >= 0, {
      message: "reference_year must be zero or greater",
    }),
    page_to_replace: z.coerce.number().refine((val) => val >= 0, {
      message: "page_to_replace must be a number and zero or greater",
    }),
    article_title: z.string().optional().nullable(),
    article_content: z.string().optional().nullable(),
  });
};

export type MagazineTemplateFormValues = z.infer<ReturnType<typeof magazineTemplateSchema>>;
